<template>
    <div>
        <v-multiselect
            @input="onChange"
            v-model="valSelected"
            :options="multiselectOptions"
            :limit="5"
            class="mt-2 order-select"
            placeholder="Escolha uma posição"
            track-by="id"
            label="display_name"
            :searchable="isSearchable"
            :loading="isLoading"
            :allow-empty="false"
            @search-change="searchDebounce"
        >
            <template slot="singleLabel" slot-scope="{ option }">
                 Candidatura para: <span class="text-orange">{{ option.display_name }}</span>
            </template>
        </v-multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: { 'v-multiselect': Multiselect },
    props: {
        options: {
            required: true,
            default: () => {}
        },
        name: {
            required: true
        },
        defaultVal: {
            required: false
        },
        isForm: {
            required: false,
        },
        isSearchable: {
            required: false,
            default: false
        },
        apiSearchEnabled: {
            required: false,
            default: false
        },
        defaultSavedZipcodeVal: {
            required: false,
        },
        defaultSuggestedZipcodeVal: {
            required: false,
        },
        optionalName: {
            required: false
        },
        isCheckout: {
            required: false
        }
    },
    data () {
      return {
          valSelected: null,
          isLoading: false,
          originalOptions: [],
          multiselectOptions: [],
          searchDebounce: () => {}
      }
    },
    created() {
        this.$root.$on('updateCartSlots', (event) => {
            if(this.name == 'onCartSlotChange') {
                this.multiselectOptions = event.detail.slotsOptions;
                this.setDefaultValue();
            }
        });

        this.$root.$on('updateCartSavedAddress', (event) => {
            if(this.name == 'onCartZipCodeChange') {
                this.valSelected = this.multiselectOptions.find(v => v.key == event.detail.zipCodeSelected) || this.multiselectOptions[0];
            }

            if(this.name == 'onCartSlotChange') {
                this.multiselectOptions = event.detail.slotsOptions;
                this.valSelected = this.multiselectOptions.find(v => v.key == event.detail.slotsSelected) || this.multiselectOptions[0];
            }
        });

        this.$root.$on('updateCartZipCodeOptions', (event) => {
            if(this.name == 'onCartZipCodeChange') {
                this.multiselectOptions = event.detail.addressesOptions;
                this.valSelected = this.multiselectOptions.find(v => v.key == event.detail.zipCodeSelected) || this.multiselectOptions[0];
            }

            if(this.name == 'onCartSlotChange') {
                this.multiselectOptions = event.detail.slotsOptions;
                this.valSelected = this.multiselectOptions.find(v => v.key == event.detail.slotsSelected) || this.multiselectOptions[0];
            }
        });

        this.$root.$on('updateCartStore', (event) => {
            if(this.name == 'onCartStoreChange' && event.detail.storeSelected) {
                this.valSelected = this.multiselectOptions.find(v => v.key == event.detail.storeSelected);
            }

            this.$root.$emit('updateCartSlots', event);
        });
    },
    mounted(){
        if(this.options && this.options.length > 0) {
            this.multiselectOptions = this.options;

            if(this.isSearchable){
                this.searchDebounce = this.debounceSearch(this.asyncFind)
                this.originalOptions = this.options;
            }

            this.setDefaultValue();
        }
    },
    methods: {
        onChange (value) {
            this.$emit('input', value);
            if(!this.isForm)
                Livewire.emit(value.saved_address ? this.optionalName : this.name, value.key);
        },
        setDefaultValue() {

            if(this.apiSearchEnabled) {
                if(this.defaultSavedZipcodeVal) {
                    this.valSelected = this.multiselectOptions.find(v => v.key == this.defaultSavedZipcodeVal);
                } else {
                    this.valSelected = this.multiselectOptions.find(v => v.key == this.defaultSuggestedZipcodeVal);
                }
            } else {
                if(!this.defaultVal)
                    this.valSelected = this.multiselectOptions[0] || '';
                else {
                    this.valSelected = this.multiselectOptions.find(v => v.key == this.defaultVal);
                    if(!this.valSelected)
                        this.valSelected = this.multiselectOptions[0];
                }
            }
            this.$emit('input', this.valSelected);
        },
        asyncFind(query) {
            if(query && query.length > 0) {
                this.isLoading = true;
                this.multiselectOptions = [];
                this.$axios.post('/zipcode/autocomplete',
                    {
                        "search" : query
                    })
                    .then((response) => {
                        this.isLoading = false;
                        this.multiselectOptions = response.data;
                    })
                    .catch((error) => {
                        this.isLoading = false;
                    });
            } else {
                this.multiselectOptions = this.originalOptions;
            }
        },
        debounceSearch(func){
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => { func.apply(this, args); }, 500);
            };
        }
    },
    watch: {
        options(newVal, oldVal) {
            if(this.isCheckout) {
                this.multiselectOptions = newVal;
                this.setDefaultValue();
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>